export const API_URL: string = "https://analyzer.inkprimelo.com.mx/api/?";
export const GET_FILTER: string = "_GET&filter=";
export const POST_FILTER: string = "_POST&filter=";
export const FILE_FILTER: string = "_FILE";
export const CLOUD_FUNCTION: string = "cloudFunction=";
export const HOOK_FUNCTION: string = "hook=";
export const COMPANY_NAME: string = "Analyzer";



// WEBPACK FOOTER //
// ./src/utils/constants.ts